import client from '../client';

export interface Review {
  id: number;
  platform: string;
  rating: number;
  content: string;
  author: string;
  response?: string;
  business_id: number;
  created_at: string;
  responded_at?: string;
  status: 'pending' | 'responded';
}

const reviewsService = {
  getReviews: async (
    businessId: number,
    params?: {
      status?: string;
      platform?: string;
    }
  ): Promise<Review[]> => {
    const response = await client.get<Review[]>(`/reviews/${businessId}`, { params });
    return response.data;
  },

  respondToReview: async (
    reviewId: number,
    response: string
  ): Promise<Review> => {
    const result = await client.post<Review>(`/reviews/${reviewId}/respond`, { response });
    return result.data;
  },

  generateResponse: async (
    reviewId: number,
    params: {
      tone?: 'professional' | 'friendly' | 'apologetic';
      keywords?: string[];
    }
  ): Promise<{ response: string; suggestions: string[] }> => {
    const response = await client.post<{ response: string; suggestions: string[] }>(
      `/reviews/${reviewId}/generate-response`,
      params
    );
    return response.data;
  },
};

export default reviewsService;
